"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANNER_IMG_URL = void 0;
exports.BANNER_IMG_URL = "https://static.snapchat.com/images/deeplink_cta_popup_banner_compressed.png";
//# sourceMappingURL=banner-img.js.map